import { showStudentSessions } from "../../../api/endpoints/students/sessions";
import { indexStudentNotes } from "../../../api/endpoints/students/notes";
import StudentReadingRoom from "../../../components/sessions/StudentReadingRoom";

export default function ReadingRoom() {
  return (
    <StudentReadingRoom
      getUserSession={(id: string | number, referrer: string) =>
        showStudentSessions(id, referrer)
      }
      indexNotes={indexStudentNotes}
    />
  );
}
